import React from 'react'
import Navbar from './global-components/navbar'
import PageHeader from './global-components/page-header'
import Mission from './section-components/mission'
import AboutUs from './section-components/about-us'
import OurPartner from './section-components/our-partner'
import CalltoAction from './section-components/calltoaction'
import ServiceTwo from './section-components/service-two'

import Client from './section-components/client'

import Footer from './global-components/footer'
import RealHome from './section-components/RealHome/RealHome'
import RegisterInterest from './section-components/RegisterInterest/RegisterInterest'
import PleasantlyPriced from './section-components/PleasantlyPriced/PleasantlyPriced'
import CommunityFeatures from './section-components/CommunityFeatures/CommunityFeatures'
import ViewPlans from './section-components/ViewPlans/ViewPlans'
import TextHeader from './section-components/TextHeader/TextHeader'
import LocationBenefits from './section-components/LocationBenefit/LocationBenefits'
import MapSection from './section-components/MapSection'
import useFetch from '../Hooks/useFetch'
import { useLocation } from 'react-router'

const Project1 = () => {
  const location = useLocation()

  const arrayNumber = location.search.replace('?id=', '')

  console.log(arrayNumber, location)

  const { data, baseUrl } = useFetch()

  const myField = data?.items.find((item, index) => {
    if (item.sys.id === arrayNumber) {
      return item
    }
  })

  const myIndex = data?.items.findIndex((item, index) => {
    if (item.sys.id === '10e6LFVI05dL75rTFRGJ0Z') {
      return item
    }
  })

  console.log(myIndex)

  // console.log(data)

  // console.log(data?.items[0].fields.title)

  // console.log(baseUrl + data?.[arrayNumber].Pageheader.title.url)
  return (
    <div>
      <Navbar />
      <PageHeader
        headertitle={myField?.fields.title}
        subheader={myField?.fields.title}
        Imagefile={myField?.fields.pTitle.fields.file.url}
        type='project'
      />
      <TextHeader projectNumber={myField} />
      <ViewPlans projectNumber={myField} />
      <RealHome
        title={myField?.fields.rTitle}
        desc={myField?.fields.rParagraph}
      />
      <PleasantlyPriced projectNumber={myField} />
      <CommunityFeatures projectNumber={myField} />
      <MapSection projectNumber={myField} />

      <LocationBenefits projectNumber={myField} />
      <RegisterInterest projectNumber={myField} />
      <Footer />
    </div>
  )
}

const planday = {
  title: 'Plan your perfect day below',
  desc: `An inspiring vista greets AZCA residents every morning in their homes above Town Square Park, with inviting trails, parkland as well as bustling shops, restaurants and entertainment to choose from below.`,
}

export default Project1
